import { defineComponent } from 'vue'
import { store } from '#stores/oneform'
import AddressFieldsVue from '../AddressFields/AddressFields.vue'
import IncidentInfoFieldsVue from '../IncidentInfoFields/IncidentInfoFields.vue'
import TypeIncidentInfoFieldsVue from '../TypeIncidentInfoFields/TypeIncidentInfoFields.vue'
import FamilyHistoryTableVue from '../FamilyHistoryTable/FamilyHistoryTable.vue'
import SignaturePadVue from '../SignaturePad/SignaturePad.vue'

export default defineComponent({
  components: {
    AddressFields: AddressFieldsVue,
    IncidentInfoFields: IncidentInfoFieldsVue,
    TypeIncidentInfoFields: TypeIncidentInfoFieldsVue,
    FamilyHistoryTable: FamilyHistoryTableVue
  },
  data() {
    const form = store.patientForm

    return {
      form,
      store,
      powerboolRequired: [
        v => v === false || v === true || 'Required'
      ],
      requiredIfText: [
        v => form.medicationListUploadType !== 'text' || !!v || 'Medication list is required when entering text'
      ],
      requiredIfFile: [
        v => form.medicationListUploadType !== 'file' || !!v || 'Please upload a medication list file'
      ]
    }
  },
  methods: {

  }
})
